"use client";
import type { KeyboardEvent, MouseEvent, ReactElement, ReactNode, RefObject, } from "react";
import { CmarkdownvisualModeProvider, type CmarkdownvisualMode, } from "./CmarkdownvisualModeContext";
import { PORTAL_KEYBOARD_WRAPPER_STYLE_BY_MODE } from "./CmarkdownvisualStyles";
interface CmarkdownvisualPortalContentProps {
    children: ReactNode;
    keyboardWrapperRef: RefObject<HTMLDivElement | null>;
    mode: CmarkdownvisualMode;
    onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void;
    tabIndex?: number;
}
export function CmarkdownvisualPortalContent({ children, keyboardWrapperRef, mode, onKeyDown, tabIndex, }: CmarkdownvisualPortalContentProps): ReactElement {
    function handleMouseDown(event: MouseEvent<HTMLDivElement>): void {
        if (event.currentTarget !== document.activeElement &&
            !event.currentTarget.contains(document.activeElement)) {
            event.currentTarget.focus({ preventScroll: true });
        }
    }
    return (<CmarkdownvisualModeProvider value={{ mode }}>
        <div ref={keyboardWrapperRef} tabIndex={tabIndex} onKeyDown={onKeyDown} onMouseDown={handleMouseDown} style={PORTAL_KEYBOARD_WRAPPER_STYLE_BY_MODE[mode]}>
          {children}
        </div>
    </CmarkdownvisualModeProvider>);
}
